import { IdentityDetailPathSchema } from '@milestone-portal/schema/path.schema';
import { ResponsiveLayout } from '@milestone-portal/ui/ResponsiveLayout/ResponsiveLayout';
import { createFileRoute } from '@tanstack/react-router';

import { IdentityDetail } from './-components/IdentityDetail';
import { MobileIdentityDetail } from './-components/MobileIdentityDetail';
import { NftDetailSkeleton } from './-components/pending/NftDetailSkeleton';
import { IdentityDetailContext } from './-logic/IdentityDetailContext';
import { useIdentityDetail } from './-logic/useIdentityDetail';

export const Route = createFileRoute('/assets/identity/$identityId')({
  component: IdentityDetailPage,
  params: {
    parse: IdentityDetailPathSchema.parse,
  },
  pendingComponent: NftDetailSkeleton,
});

function IdentityDetailPage() {
  return (
    <IdentityDetailContext.Provider value={useIdentityDetail()}>
      <ResponsiveLayout
        desktop={<IdentityDetail />}
        mobile={<MobileIdentityDetail />}
      />
    </IdentityDetailContext.Provider>
  );
}
